import { Button, useDisclosure } from '@chakra-ui/react';

import GrantAccessModal from '../GrantAccessModal';

import { GrantAccessButtonProps } from './types';

function GrantAccessButton({ employeeId, employeeName, onGrant }: GrantAccessButtonProps) {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <>
      <Button
        size="sm"
        variant="outline"
        height="40px"
        onClick={(e) => {
          e.stopPropagation();
          onOpen();
        }}
      >
        Grant Access
      </Button>
      <GrantAccessModal
        employeeId={employeeId}
        employeeName={employeeName}
        isOpen={isOpen}
        onClose={onClose}
        onGrant={onGrant}
      />
    </>
  );
}

export default GrantAccessButton;
